(function (app, ng) {
    app.factory("eventPerformanceService", ["industryStandardsConstant", "eventCollectionFactory",
        function eventPerformanceService(industryStandardsConstant, eventCollectionFactory) {
            var service = {
                getCollectionItem: getCollectionItem,
                getPerformanceItem: getPerformanceItem
            };


            //find an event collection's item & its performance timeline array that contains the given event type i.e. Client Educational Events
            function getCollectionItem(eventType) {
                var collectionItem = null;

                collectionItem = eventCollectionFactory.find(function (element) {
                    return element.eventTypes.includes(eventType);
                });

                return collectionItem;
            }

            //return a performance item based on the metric name & value from the collection item's given performance timeline array
            function getPerformanceItem(array, name, value, icon) {
                var _performanceItem, performanceItem = {};
                _performanceItem = array.find(function (element) {
                    return element.name.includes(name);
                });
                performanceItem = ng.extend({}, _performanceItem, {
                    icon: icon || _performanceItem.icon, //set icons to be optional. Takes default icon if not set
                    displayValue: _performanceItem.displayValue(value),
                    isGood: _performanceItem.standard.lowerBound !== null ? _performanceItem.isGood(value) : null,
                    hasStandards: _performanceItem.standard.lowerBound !== null ? true : false
                });

                return performanceItem;
            }

            return service;
        }
    ]);
})(window.app, window.angular);